<div class="emds">
  <div class="modal-default" id="{{Id}} + 'confirm'">
    <div *ngIf="!hideHeader" class="modal-header">
      <span translate>{{modalTitleText}}</span>
    </div>
    <div class="modal-body"
      [innerHTML] = "bodyText | safeHtml">
    </div>
    <div class="modal-footer">
      <button id="{{Id}} + '-yes-button'" class="btn btn-primary yes-btn" (click)="yesSelected()" translate>{{yesButtonText}}</button>
      <button *ngIf="!hideNoButton" id="{{Id}} + '-no-button'" class="btn btn-light no-btn" (click)="noSelected()" translate>{{noButtonText}}</button>
    </div>
  </div>
</div>
